/** @format */

import React from 'react';

const RoleContext = React.createContext({ selectedRole: undefined, setSelectedRole: null });

const RoleProvider = RoleContext.Provider;

export { RoleProvider, RoleContext };
